import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SvgIcons } from "@tripian/react";


import Model from "@tripian/model";
import SearchContainer from "../../TripPlan/layouts/TripLayout/Container/SearchContainer/SearchContainer";
import useTranslate from "../../../hooks/useTranslate";

interface InterestsPoisProps {
    searchResults: Model.Poi[];
    loading: boolean;
    title: string;
    t: (value: Model.TranslationKey) => string;
}

const InterestsPois: React.FC<InterestsPoisProps> = ({ searchResults, loading, title, t}) => {
    const navigate = useNavigate();
    useEffect(() => {
    }, [searchResults]);
    

    return (
        <div className="w-full py-6 px-4">
            <div className="max-w-7xl mx-auto">
                {/* Attraction Cards Grid */}
                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-6 min-h-[400px] relative">
                    {loading ? (
                        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-80">
                            <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-color border-t-transparent"></div>
                        </div>
                    ) : searchResults?.map((poi) => (
                        <div
                            key={poi.id}
                            onClick={() => navigate(`/place/${poi.id}`)}
                            className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer group"
                        >
                            <div className="relative h-48">
                                <img
                                    src={poi.image?.url || 'placeholder-image.jpg'}
                                    alt={poi.name}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                                />
                            </div>
                            
                            <div className="p-4">
                                <h3 className="font-16-h text-gray-900 mb-2 line-clamp-2">
                                    {poi.name}
                                </h3>
                                
                                {/* Rating */}
                                <div className="flex items-center mb-2">
                                    <SvgIcons.Star className="w-4 h-4 text-yellow-400 mr-1" />
                                    <span className="text-sm font-medium text-gray-900">
                                        {poi.rating || 'N/A'}
                                    </span>
                                    <span className="text-sm text-gray-500 ml-1">
                                        ({poi.ratingCount || 0}<span className="hidden md:inline"> {t('reviews')}</span>)
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                    {!loading && searchResults.length === 0 && (
                        <div className="absolute inset-0 flex items-center justify-center text-gray-500">
                            {t('valai.noAttractionsFound')}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InterestsPois;